import { callApiWithAuthorization } from "../CallApi";
import Color from "../../Components/Helpers/color";

export async function getUserDataFromContext(loggedInUser) {
    let azureId = loggedInUser.localAccountId;
    let phoneNumber = loggedInUser.idTokenClaims.extension_Phone || "";
    let countryCode = loggedInUser.idTokenClaims.extension_Country ? loggedInUser.idTokenClaims.extension_Country.match(/\(([^)]+)\)/)?.[1] || "" : "";
    let phone = countryCode + phoneNumber;
    let given_name = loggedInUser.idTokenClaims.given_name || "";
    let family_name = loggedInUser.idTokenClaims.family_name || "";
    let displayName = (loggedInUser.name === "unknown" || loggedInUser.name === undefined) ? given_name + " " + family_name : loggedInUser.name;

    let response = {
        azureId: azureId,
        bgColor: Color(),
        email: loggedInUser.username,
        firstName: given_name,
        lastName: family_name,
        displayName: displayName,
        jobTitle: loggedInUser.idTokenClaims.jobTitle || "",
        companyName: loggedInUser.idTokenClaims.extension_CompanyName || "",
        phone: phone.trim() || "",
        userVerified: loggedInUser.idTokenClaims.extension_IsEmailSameAsCopilot === true, // check using === to make sure it is true only if the value is present
        numberOfEmployees: loggedInUser.idTokenClaims.extension_CompanySize || "",
        isFromCopilot: loggedInUser.idTokenClaims.extension_IsEmailSameAsCopilot === true, // check using === to make sure it is true only if the value is present
    }
    return response;
}

export async function getNumberOfOrganisationWithSameName(urlName, id = "") {
    const request = await callApiWithAuthorization(
        "/api/v0/organization/count",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                urlName,
                id
            })
        }
    );
    const response = await request.json();
    return response[0].low;
}

export async function completeRegistration(loggedInUser, organizationId, roleId) {
    const data = await getUserDataFromContext(loggedInUser);
    let request = await callApiWithAuthorization("/api/v0/completeRegistration", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            email: data.email,
            azureId: data.azureId,
            userData: {
                azureId: data.azureId,
                bgColor: Color(),
                email: data.email,
                firstName: data.firstName || "",
                lastName: data.lastName || "",
                displayName: data.displayName || "",
                jobTitle: data.jobTitle || "",
                companyName: data.companyName || "",
                phone: data.phone || "",
                userVerified: data.userVerified,
                isDesignerUser: true,
            },
            signUpOrgId: organizationId,
            roleId: roleId,
        })
    });
    let response = await request.json();
    return response;

}

export async function updateOrganization(organization) {
    const organizationId = organization._id;
    delete organization._id;
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(organization),
    });
    const response = await request.json();
    return response;
}

export async function getUserAndItsOrganizations(email) {
    debugger
    const request = await callApiWithAuthorization(`/api/v0/user/${email}/organizations`);
    const response = await request.json();
    return response;
}

export async function getUserItsOrganizationAndSubscription(email, organizationId) {
    const request = await callApiWithAuthorization(`/api/v0/user/${email}/organization/${organizationId}/subscription`);
    const response = await request.json();
    return response;
}

export async function getOrganization(id) {
    const request = await callApiWithAuthorization(`/api/v0/organization/${id}`);
    const response = await request.json();
    return response;
}

export async function getLibraryData() {
    const request = await callApiWithAuthorization("/api/v0/getLibraryData");
    const response = await request.json();
    return response;
}

export async function getOrganizationUsers(organizationId) {
    const request = await callApiWithAuthorization(`/api/v0/organization/${organizationId}/users`);
    const response = await request.json();
    return response;
}

export async function inviteUserToOrganization(organizationId, roleId, users) {
    let request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/inviteUserToOrganization", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            roleId: roleId,
            emails: users,
            bgColor: Color()
        })
    });
    let response = await request.json();
    return response;
}

export async function changeUserOrganizationRole(organizationId, roleId, userId) {
    let request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/changeUserOrganizationRole", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            roleId: roleId,
            userId: userId
        })
    });
    let response = await request.json();
    return response;
}

export async function removeUserFromOrganization(organizationId, userId) {
    await callApiWithAuthorization(`/api/v0/organization/${organizationId}/removeUserFromOrganization/${userId}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        }
    });
}

export async function changeOrganizationOwner(organizationId, currentOwnerId, newOwnerId) {
    let response = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/changeOrganizationOwner", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            currentOwnerId: currentOwnerId,
            newOwnerId: newOwnerId
        })
    });
    let result = await response.json();
    return result;
}

export async function validateOrganizationName(name) {
    let request = await callApiWithAuthorization("/api/v0/validateOrganizationName", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            organizationName: name.trim().replace(/\s/g, "")
        })
    })
    let response = await request.json();
    return response;
}